module.exports = __webpack_public_path__ + "img/fangan6.5de57d8e.png";